import { createElementBlock as l, openBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function r(c, e) {
  return t(), l("svg", n, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M10.5 1.75c-4.339 0-7.875 3.536-7.875 7.875S6.161 17.5 10.5 17.5v2.705l1.347-.863c1.956-1.255 5.524-3.964 6.352-8.07.113-.53.176-1.08.176-1.647 0-4.339-3.536-7.875-7.875-7.875m0 1.75a6.112 6.112 0 0 1 5.987 7.414l-.002.006-.002.005c-.52 2.58-2.508 4.48-4.233 5.821v-1.172l-.984.123a6 6 0 0 1-.766.053 6.11 6.11 0 0 1-6.125-6.125A6.11 6.11 0 0 1 10.5 3.5"
    }, null, -1)
  ])]);
}
const a = { render: r };
export {
  a as default,
  r as render
};
